export enum CommentsType {
    questions = "questions",
    suggestions = "suggestions",
    opinions = "opinions",
}
